import MobileSeoSection from './MobileSeoSection';

export default MobileSeoSection;
